import React from 'react';
import GlobalMenu from '../../components/global/menu/GlobalMenu';
import Notice from '../../components/contents/notice/Notice';
export default function NoticePage(){
    //console.log("NoticePage>>>>>>>>>>>>>>>>>>>>");
    return (
        <div id="wrap" className="main sub_page">
        <div className="inner">
            <GlobalMenu />
        </div>

        <div className="notice">
            <Notice />
        </div>
    </div>

    );
}